export default "__VITE_ASSET__6nSqLLOO__"